import styled from "styled-components"

export const PipelineContainer = styled.div`
  width: 100%;
  height: 80vh;
  padding: 20px;
  padding-top: 0px;
  display: flex;
  background-color: ${({ backgroundColor }) => (backgroundColor ? backgroundColor : "#efeded")};
  grid-gap: 10px;
  overflow: auto;
  div:first-child {
    margin-left: auto;
  }
  div:last-child {
    margin-right: auto;
  }
`
